import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets-lxgj4vgw.emergentagent.net/job_daab-recruit/artifacts/kveh0gcx_file_0000000029048211809fc80c6002540d.webp";

const links = [
  { label: "Services", href: "#services" },
  { label: "Employers", href: "/employers" },
  { label: "Candidates", href: "/candidates" },
  { label: "Process", href: "#process" },
  { label: "Vacancies", href: "#roles" },
  { label: "Due Diligence", href: "/due-diligence" },
  { label: "Partners", href: "#partners" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.header
      data-testid="site-nav"
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled ? "bg-white/85 backdrop-blur-md border-b border-[#e4e4e7]" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="shrink-0">
          <img src={LOGO} alt="DAAB Consulting Recruitment Services" className="h-9 md:h-11 w-auto object-contain" />
        </a>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="font-body text-sm text-[#52525b] hover:text-[#0a0a0a] link-underline transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3 md:gap-5">
          <a
            href="#hire"
            data-testid="nav-cta"
            className="hidden lg:inline-flex items-center gap-2 font-head uppercase text-sm tracking-wide bg-[#ff3b30] hover:bg-[#ff5248] text-white px-6 py-3 font-600 hover:-translate-y-0.5 transition-all duration-300"
          >
            Hire Talent
          </a>

          <button
            data-testid="nav-mobile-toggle"
            className="lg:hidden text-[#0a0a0a]"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
            className="lg:hidden overflow-hidden bg-white border-b border-[#e4e4e7]"
          >
            <div className="px-6 py-6 flex flex-col gap-5">
              {links.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  onClick={() => setOpen(false)}
                  className="font-head uppercase text-2xl tracking-tight text-[#0a0a0a]"
                >
                  {l.label}
                </a>
              ))}
              <a
                href="#hire"
                onClick={() => setOpen(false)}
                className="font-head uppercase text-sm bg-[#ff3b30] text-white px-6 py-3 w-max"
              >
                Hire Talent
              </a>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </motion.header>
  );
};
